import { pushModalTransition } from '@core/js/actions/modalActions';
import { init as sizeGuideInit } from '@product/js/components/productSizeGuideComponent';

export function launchSizeGuideOnPageLoad(event) {
    const payload = pushModalTransition(sizeGuideInit, {}, event, 'launchSizeGuideOnPageLoad');

    $.event.trigger({
        type: payload.type,
        payload: payload
    });
}

export function findSelectedConversion(previousConversionSlug, availableConversions) {
	const conversionCode = _.last(_.split(previousConversionSlug, '_'));

    for (const conversion of availableConversions) {
        if (_.endsWith(conversion.slug, conversionCode)) {
            return conversion.slug;
        }
    }
    return null;
}
